module.exports = __webpack_public_path__ + "static/media/brentrambo.202ba994.gif";